import { $ } from '../utils/index.js';
import { renderPageCta, renderPageHero } from './shared.js';

const DELIVERY_POINTS = [
  {
    title: 'Senior execution',
    body: 'You work directly with a focused team that cares about architecture, delivery quality, and clear communication from start to launch.',
  },
  {
    title: 'US and European collaboration',
    body: 'For US teams, Kosova creates a useful async handoff window. For European teams, it keeps daily collaboration close, direct, and easy to manage.',
  },
  {
    title: 'Product-minded delivery',
    body: 'We do not just code tasks. We help shape scope, reduce waste, and make sure the software solves the right problem cleanly.',
  },
  {
    title: 'Web, mobile, and AI',
    body: 'ARKRON supports product delivery across web platforms, mobile apps, AI features, consulting, and ongoing support.',
  },
] as const;

const WHY_KOSOVO = [
  {
    title: 'Close communication',
    body: 'Fast feedback cycles, direct calls, and less delay between business decisions and engineering execution.',
  },
  {
    title: 'Strong cost-to-quality balance',
    body: 'Clients get a capable software partner without the overhead and inefficiency that often comes with larger vendor structures.',
  },
] as const;

export function renderOutsourcingKosovo(): void {
  const el = $('#page-software-outsourcing-kosovo');
  if (!el) return;

  el.innerHTML = `
    ${renderPageHero({
      label: 'Kosova Delivery',
      title: 'Software outsourcing partner in Kosova',
      intro:
        'ARKRON helps US and European teams outsource web, mobile, AI, and product engineering to a Kosova-based partner that values clarity, reliable execution, and long-term quality.',
      kicker: 'Why teams choose this',
      stack: ['Kosova-based team', 'Web, mobile, AI', 'Senior execution'],
    })}
    <section class="section">
      <div class="container section-head animate-on-scroll">
        <p class="section-kicker">What clients get</p>
        <h2 class="section-title section-title-medium">A practical outsourcing setup, without the usual drag.</h2>
        <p class="section-intro">The point is not to hand work off blindly. The point is to gain a team that can think, build, communicate clearly, and help carry the product forward across US and European working rhythms.</p>
      </div>
      <div class="container process-grid">
        ${DELIVERY_POINTS.map((item, index) => `
          <article class="process-card animate-on-scroll" style="animation-delay: ${(index % 2) * 0.05}s">
            <span class="process-number">0${index + 1}</span>
            <h3>${item.title}</h3>
            <p>${item.body}</p>
          </article>
        `).join('')}
      </div>
    </section>
    <section class="section">
      <div class="container section-head animate-on-scroll">
        <p class="section-kicker">Why Kosova</p>
        <h2 class="section-title section-title-medium">Why companies look for outsourcing partners in Kosova.</h2>
      </div>
      <div class="container split-showcase">
        ${WHY_KOSOVO.map((item, index) => `
          <article class="split-card split-card-primary animate-on-scroll" style="animation-delay: ${index * 0.05}s">
            <h3>${item.title}</h3>
            <p>${item.body}</p>
          </article>
        `).join('')}
      </div>
    </section>
    <section class="section">
      <div class="container cta-panel animate-on-scroll cta-panel-compact">
        <div>
          <p class="section-kicker">Outsourcing in Kosova</p>
          <h2 class="section-title light section-title-medium">If you are a US or European team looking for a software outsourcing partner in Kosova, let&apos;s talk.</h2>
          <p class="section-intro light">We can help with web development, mobile apps, AI integration, consulting, and product delivery through a focused, high-trust working model.</p>
        </div>
        <div class="cta-panel-actions">
          <a href="/contact-us" class="btn-primary">Contact Us</a>
        </div>
      </div>
    </section>
  `;
}
